import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },{
      path: '/consent',
      name: 'consent',
      component: () => import('./views/Consent.vue')
    },{
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('./views/Dashboard.vue')
    },{
      path: '/register',
      name: 'register',
      component: () => import('./views/Register.vue')
    }
  ]
})
